import styled, { css } from 'styled-components'
import {
  colors,
  device,
  headerZIndex,
  host,
  themeClassName,
} from '../../styles/GlobalVariables'
import { Header } from '../Header/Header'
import { Container as SubMenuContainer } from '../Header/SubMenu.styles'

export const StyledHeader = styled(Header)``

export const Banners = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  z-index: 2;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
`

export const BackgroundLogo = styled.div`
  position: absolute;
  left: 0;
  top: 100px;
`

export const LogoWrapper = styled.div`
  position: relative;
`

export const FooterSpacer = styled.div<{ height: number }>`
  width: 100vw;
  height: ${props => props.height}px;
`

const menuHeight = { d: 64, m: 48 }
const subMenuHeight = { d: 29, m: 29 }

// In the native app the Header (and its own HeaderPlaceHolder) is hidden and the
// SubMenu is rendered fixed to the viewport top instead, so nothing reserves its
// space in flow. This pushes the content below it (e.g. TopBanner) down to match.
export const SubMenuPlaceHolder = styled.div`
  display: none;

  ${host.nativeApp} & {
    display: block;
    height: ${subMenuHeight.m}px;
  }
`
export const Container = styled.div<{
  subMenu: boolean
  hasHero: boolean
  showingHeader: boolean
  heroHeight?: number
  headerHeight?: number
  isFaceLift?: boolean
  backgroundColor?: string
}>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100vw;
  overflow: hidden;
  overflow-y: auto;

  ${BackgroundLogo} {
    top: ${({ subMenu }) =>
      subMenu ? `${-menuHeight.m - subMenuHeight.d}px` : `-${menuHeight.m}px`};

    ${device.medium} {
      top: ${({ subMenu }) =>
        subMenu ? ` ${-64 - subMenuHeight.d - 28}px;` : `${-64 - 28}px;`};
    }
  }

  background: ${colors.white};

  ${props =>
    props.isFaceLift
      ? css`
          background: ${props.backgroundColor};
        `
      : ''}
  &${themeClassName.vod} {
    background: ${colors.tvGuideDark};
  }

  &${themeClassName.vodMain} {
    background: ${colors.tvGuideDark};

    ${props =>
      props.hasHero &&
      'background: linear-gradient(180deg, rgba(18,18,18,1) 0, rgba(18,18,18,0) 21vh, rgba(18,18,18,1) 85vh, rgba(18,18,18,1) 100%);'}
    ${device.medium} {
      ${({ hasHero }) => hasHero && `background: ${colors.tvGuideDark};`}
      ${({ hasHero, heroHeight }) =>
        hasHero &&
        heroHeight &&
        `background: linear-gradient(180deg, rgba(18,18,18,1) 0, rgba(18,18,18,0) ${
          heroHeight * 0.23
        }px, rgba(18,18,18,0) ${heroHeight * 0.28}px, rgba(18,18,18,1) ${
          heroHeight * 0.85
        }px, rgba(18,18,18,1) 100%);`}
    }
  }

  ${host.nativeApp} & {
    ${BackgroundLogo} {
      top: -49px;
    }

    .playkit-in-browser-fullscreen-mode {
      :before {
        content: '';
        display: block;
        position: fixed;
        inset: 0;
        background: ${colors.black};
        z-index: 0 !important;
      }
    }
  }

  ${host.nativeApp} & ${StyledHeader} {
    display: none;
  }

  > ${SubMenuContainer} {
    display: none;

    ${host.nativeApp} & {
      display: flex;
      padding-right: 19px;
      z-index: ${headerZIndex};
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);

      ${themeClassName.vod} & {
        background: ${colors.darkHeaderBg};
        box-shadow: unset;
      }

      ${themeClassName.vodMain} & {
        background: linear-gradient(
          180deg,
          #121212 0%,
          rgba(18, 18, 18, 0) 100%
        );
        box-shadow: unset;

        &.is-scrolled {
          background: ${colors.darkHeaderBg};
          box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
`
